import { render, staticRenderFns } from "./OrderBind.vue?vue&type=template&id=690b6396&scoped=true&"
import script from "./OrderBind.vue?vue&type=script&lang=js&"
export * from "./OrderBind.vue?vue&type=script&lang=js&"
import style0 from "./OrderBind.vue?vue&type=style&index=0&id=690b6396&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690b6396",
  null
  
)

export default component.exports